import { useAppSelector } from '@frontend/common';
import { ProductConstraintData, isProductConstraintData } from '@frontend/constraint/types';
import { formStore, updateField } from '@frontend/repository';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { ProductConstraintDataInputProps } from './product-constraint-data-input.component';

interface ViewProps {
    formValues: ProductConstraintData;
}

const useProductConstraintDataInput = (props: ProductConstraintDataInputProps): ViewProps => {
    const store = useAppSelector(useSelector, formStore);
    const formValues = store[props.formId]?.value['data'];

    useEffect(() => {
        if (!isProductConstraintData(store[props.formId]?.value['data'])) {
            props.dispatch(updateField({ formId: props.formId, key: 'data', value: { product_id: null } }));
        }
    }, []);

    return {
        formValues
    };
};

export default useProductConstraintDataInput;
